import { IAllocationDimension } from "helpers/allocation-dimension";
import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";

export class MaxCustomAttributesRule extends Validator<IAttributeData[], IAttributeDataError> {
    allocationDimension: IAllocationDimension;
    noAttributesColumns: string[];
    maxCustomAttributesLimit: number;

    constructor(
        noAttributesColumns: string[],
        allocationDimension: IAllocationDimension,
        customAttributesLimit: number
    ) {
        super();
        this.allocationDimension = allocationDimension;
        this.noAttributesColumns = noAttributesColumns;
        this.maxCustomAttributesLimit = customAttributesLimit;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let customAttributesSize = 0;
        const maxCustomAttributesLimit = this.maxCustomAttributesLimit;
        if (!errors[RuleType.MaxCustomAttributesRule] && this.allocationDimension) {
            const headers = Object.keys(model[0] || {});
            const existingCustomAttributesSize = this.allocationDimension.attributes.keys.reduce(
                (acc, attribue) => acc + (attribue.display?.is_user_defined ? 1 : 0),
                0
            );
            customAttributesSize = headers.reduce((acc, column) => {
                const expression = buildColumnExpression(column);
                if (
                    !this.noAttributesColumns.some((field) => expression.test(field)) &&
                    !this.allocationDimension.attributes.keys.some((attribue) => expression.test(attribue.display_name))
                ) {
                    return acc + 1;
                }

                return acc;
            }, existingCustomAttributesSize);
        }

        const validationErrors =
            customAttributesSize > maxCustomAttributesLimit
                ? {
                      ...errors,
                      [RuleType.MaxCustomAttributesRule]: formatMessage(
                          "With this upload you will exceed the limit of |size| custom attributes. Please reduce the number of attributes and try again.",
                          { size: maxCustomAttributesLimit }
                      ),
                  }
                : errors;

        return super.validate(model, validationErrors);
    }
}
